import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SideBarComponent } from './side-bar.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { MatRippleModule } from '@angular/material/core';
import { MatBadgeModule } from '@angular/material/badge';
import { ConfirmationDialogModule } from '../confirmation-dialog';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { PanicControlModule } from './../panic-control/panic-control.module'
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';


@NgModule({
    declarations: [
        SideBarComponent
    ],
    imports: [
        CommonModule,
        MatSidenavModule,
        MatListModule,
        MatIconModule,
        RouterModule,
        MatRippleModule,
        MatBadgeModule,
        MatDialogModule,
        ConfirmationDialogModule,
        PanicControlModule,
        MatButtonModule
    ],
    exports: [
        SideBarComponent
    ]
})
export class SideBarModule { }
